import { BaseModel } from '@red/data-access';
import {  Expose } from 'class-transformer';
import { IInformationType } from '../interfaces/information-type.interface';


export class InformationTypeModel extends BaseModel implements IInformationType{
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;
}
